import { useMemo } from 'react'

import { useApolloClient } from '@apollo/client'

import {
  approvedAtFilter,
  createCategoryAsyncFilter,
  createCurrencyAsyncFilter,
  createProjectAsyncFilter,
  createReimbursableCurrencyAsyncFilter,
  createSubcategoryAsyncFilter,
  creationTypeFilter,
  documentTypeFilter,
  internalReferenceFilter,
  reimbursableFilter,
  reportDateFilter,
  statusFilter,
} from 'modules/expenses/components/expenses/DataCollection/filters'

import { reportedByFilter } from './_Filters/reportedByFilter'

interface UseMyExpensesFiltersProps {
  companyId: number
}

export const useMyExpensesFilters = ({ companyId }: UseMyExpensesFiltersProps) => {
  const apolloClient = useApolloClient()

  return useMemo(
    () => ({
      approvedAt: approvedAtFilter(),
      category: createCategoryAsyncFilter(apolloClient, companyId),
      reviewRequestAt: reportDateFilter(),
      currency: createCurrencyAsyncFilter(apolloClient, companyId),
      documentType: documentTypeFilter(),
      creationType: creationTypeFilter(),
      internalReference: internalReferenceFilter(),
      reimbursable: reimbursableFilter(),
      project: createProjectAsyncFilter(apolloClient),
      reimbursableCurrency: createReimbursableCurrencyAsyncFilter(apolloClient, companyId),
      reportedBy: reportedByFilter(),
      status: statusFilter(),
      subcategory: createSubcategoryAsyncFilter(apolloClient, companyId),
    }),
    [apolloClient, companyId]
  )
}
